import styled from 'styled-components';

export const PrintFooter = styled.div`
    display: none;

    position: fixed;
    bottom: 0;

    font-size: 90%;

    opacity: 0.5;

    align-items: center;
    justify-content: center;

    @media print {
        display: flex;
    }
`;
